export const FONT_COLOR: Record<string, string> = {
  black: '#000000',
  white: '#FFFFFF',
};
